export const ErrorMessages = {
    PipeLineStageMaxLimit: 'Maximum 15 stages are allowed in a pipeline',
    UnreadConversationSelected: 'Please select read converstion only.',
 };

 export const InfoMessages = {
    ArchiveConversation: 'You can no longer exchange messages in an archived conversation.',
 };

